import {IListItem} from "../../list-page/interfaces/interfaces";
import {FreePluginsDM} from "../interfaces";

export const getIListItemByFreePluginItem =  (item :FreePluginsDM,imgCdnDomain:string): IListItem => {

    let listItem = {
        documentName: item.documentName,

        documentUrlPath: item.documentUrlPath,
        thumb: imgCdnDomain + item.thumb,
        msrp: item.skU_MSRP,
        skuPrice: item.skuPrice,
        discount: item.discount,
        skuid: item.skuid,
        skuNumber: item.skuNumber,
        note: item.note,

        couponCode: item.couponCode,
        couponCampaignID: item.couponCampaignID,
        couponPrice: item.couponPrice,

        reviewsTotal: item.reviewsTotal,
        rating: item.rating,

        badgeText: item.badgeText,
        badgeClass: item.badgeClass,
        skuEnabled : item.skuEnabled,
        isWishlist : true
    } as IListItem;

    return listItem;
};